/**
 * @module lib/Typography
 */
export * from './Heading.jsx';
export * from './Text.jsx';
